import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';

// Gsap Animation

gsap.registerPlugin(ScrollTrigger);

gsap.to('.section-scroll .section__image', {
	scrollTrigger: {
		trigger: '.section-scroll', // Określenie sekcji wyzwalającej animację
		start: 'top top', // Animacja zaczyna się, gdy górna krawędź sekcji dotyka górnej krawędzi okna
		end: 'bottom top', // Animacja kończy się, gdy dolna krawędź sekcji dotyka górnej krawędzi okna
		scrub: true, // Umożliwia synchronizację animacji z przewijaniem
	},
	y: '50%', // Przesunięcie tła o 200px (możesz dostosować)
	ease: 'none', // Tło porusza się zgodnie z przewijaniem
});



const sectionContent = document.querySelector('body');


if (sectionContent) {
	Array.from(sectionContent.querySelectorAll(
		'.wysywig h1, .wysywig h2, .wysywig h3, .wysywig h4, .wysywig h5, .wysywig h6, .wysywig .h1, .wysywig .h2, .wysywig .h3, .wysywig li, .wysywig p, .gsap'
	)).forEach((element) => {
		const delay = element.dataset.delay ? parseFloat(element.dataset.delay) : 0;
		gsap.from(element, {
			scrollTrigger: element,
			y: 40,
			opacity: 0,
			duration: 0.8,
			delay: delay,
		});
	});
}

import Lenis from 'lenis'

const lenis = new Lenis({
	duration: 1.45,
	direction: 'vertical',
	gestureDirection: 'vertical',
	smooth: true,
	mouseMultiplier: 1,
	smoothTouch: false,
	touchMultiplier: 2,
	infinite: false,
	anchors: true
});

function raf(time) {
	lenis.raf(time);
	requestAnimationFrame(raf);
}

requestAnimationFrame(raf);


// Open or Close mobile menu

const mobileButtonMenu = document.getElementById('mobile-button-menu');

if (mobileButtonMenu) {
	mobileButtonMenu.addEventListener('click', () => {
		document.body.classList.toggle('is-menu-open');
		mobileButtonMenu.classList.toggle('is-active');
	})
}

// Open popup on offer icon click

document.addEventListener("DOMContentLoaded", function () {
	const button = document.querySelector(".section-hero__button");

	if (button) {
		button.addEventListener("click", function () {
			const currentSection = button.closest("section"); // Znalezienie sekcji, w której jest przycisk
			const nextSection = currentSection.nextElementSibling; // Pobranie kolejnej sekcji

			if (nextSection) {
				nextSection.scrollIntoView({ behavior: "smooth" }); // Płynne przewinięcie
			}
		});
	}
});

const popup = document.querySelector('.popup');
const popup_content = document.querySelector('.popup__content');

document.addEventListener('DOMContentLoaded', function () {
	// Pobieramy wszystkie elementy z atrybutem data-id
	const elements = document.querySelectorAll('[data-id]');

	// Dodajemy nasłuchiwacz na każde z tych elementów
	elements.forEach(function (element) {
		element.addEventListener('click', function () {

			// Pobieramy wartość data-id
			var id = this.getAttribute('data-id');

			var xhr = new XMLHttpRequest();
			xhr.open('POST', myAjax.ajaxurl, true);
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
			xhr.onreadystatechange = function () {
				if (xhr.readyState === 4 && xhr.status === 200) {
					var response = JSON.parse(xhr.responseText);
					popup.classList.add('is-active');
					document.body.classList.add('is-overflow');

					setTimeout(function () {
						popup_content.innerHTML = response.data.data;
					}, 500);

					setTimeout(function () {
						var targetElement = popup_content.querySelector('.single-person-popup');
						if (targetElement) {
							targetElement.classList.add('is-active');
						}
					}, 600);
				}

			};

			var data = {
				action: 'person',
				id: id
			};

			var encodedData = [];
			for (var key in data) {
				encodedData.push(encodeURIComponent(key) + '=' + encodeURIComponent(data[key]));
			}
			encodedData = encodedData.join('&');

			xhr.send(encodedData);
		});
	});
});

document.addEventListener('click', function (event) {
	if (event.target.matches('.popup__close')) {
		document.body.classList.remove('is-overflow');
		popup.classList.remove('is-active');
		popup.querySelector('.single-person-popup').classList.remove('is-active');
	}
});